import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage, Language } from '../../lib/i18n';
export function LanguageSelector() {
  const {
    lang,
    setLang
  } = useLanguage();
  return <div className="flex items-center gap-1.5 bg-white/5 hover:bg-white/10 transition-colors px-2 py-1.5 rounded-lg border border-white/10" data-id="element-2039">
      <Globe className="w-4 h-4 text-white/60" data-id="element-2040" />
      <select value={lang} onChange={e => setLang(e.target.value as Language)} className="bg-transparent text-white/80 text-sm font-bold outline-none cursor-pointer appearance-none pr-2 [&>option]:bg-[#141414] [&>option]:text-white" data-id="element-2041">
        <option value="es" data-id="element-2042">ES</option>
        <option value="en" data-id="element-2043">EN</option>
        <option value="de" data-id="element-2044">DE</option>
        <option value="pt" data-id="element-2045">PT</option>
        <option value="zh" data-id="element-2046">中文</option>
      </select>
    </div>;
}